/*@flow*/
import type { Element } from 'react';
import React from 'react';

type PropsT = {
  id: string,
  value: string,
  text: string,
  name: string,
  checked: boolean,
  onChange: (any) => any,
};

export default function Checkbox(locals: PropsT): Element<'div'> {
  return (
    <div className="d-flex align-items-center checkbox-item">
      <label className="checkbox-label flex-grow-1" htmlFor={locals.id}>
        {locals.text}
      </label>
      <input
        type="checkbox"
        className="checkbox-control ml-auto"
        checked={locals.checked}
        value={locals.value}
        onChange={(e) => {
          locals.onChange(e.target.value);
        }}
        name={locals.name}
        id={locals.id}
      />{' '}
    </div>
  );
}
